import { Box, Typography } from '@mui/material';
import ArrayTable from '../../../../components/Grid/ArrayTable';
import DataNotFound from '../../../../components/Reports/DataNotFound';

export const TableForArrayTable = ({ title, arr = [] }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <Typography variant="h5" fontWeight={600}>
        {title}
      </Typography>
      {arr.length === 0 ? (
        <DataNotFound />
      ) : (
        arr.map((t, idx) => (
          <Box
            key={`${title}-${t.name || 'all'}-${idx}`}
            sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}
          >
            {t.name && (
              <Typography fontWeight={600} variant="h6">
                {t.name}
              </Typography>
            )}
            <ArrayTable
              headers={t.headers}
              rows={t.rows}
              dense
              footer={
                Array.isArray(t.headers)
                  ? t.headers.map((label, idx) => {
                      const hoursIdx = t.headers.findIndex((h) =>
                        String(h).toLowerCase().includes('hours')
                      );
                      if (idx === hoursIdx) {
                        const total = (t.rows || []).reduce((sum, row) => {
                          const val = +row[hoursIdx];
                          return Number.isNaN(val) ? sum : sum + val;
                        }, 0);
                        return (+total.toFixed(2)).toString();
                      }
                      return '';
                    })
                  : undefined
              }
            />
          </Box>
        ))
      )}
    </Box>
  );
};
